import styled from 'styled-components'
import RangeSlider from 'src/components/form/RangeSlider'
import { H2, TextBody } from 'src/styles/Typography'

const formatNumber = (num) => {
  return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

const RangeSliderIncome = ({ min, max, value, ...props }) => {
  return (
    <RangeSliderIncomeWrapper>
      <ValueContainer>
        <H2>${formatNumber(value)} or more</H2>
      </ValueContainer>
      <RangeContainer>
        <TextBody>${min / 1000}K</TextBody>
        <RangeSlider min={min} max={max} value={value} {...props} />
        <TextBody>${max / 1000}K</TextBody>
      </RangeContainer>
    </RangeSliderIncomeWrapper>
  )
}

const ValueContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: -1rem 0 1rem 0;
`

const RangeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

const RangeSliderIncomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export default RangeSliderIncome
